<template>
  <div class="contract-name">
    <!--收件箱、待签的、已结束-->
    <template v-if="applyType === 'signList'">
      <!--待签的-->
      <template v-if="signInfo.status === 0 || signInfo.status === -1">
        <!--待我签-->
        <el-tooltip
          v-if="signInfo.selfSign === 1"
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <!--          <span @click="toSign(signInfo.signNo, signInfo.approveId)">{{-->
          <span
            @click="
              handleClickLookContract(signInfo.signNo, signInfo.approveId)
            "
            >{{ signInfo.name }}</span
          >
        </el-tooltip>
        <!--待ta签-->
        <el-tooltip
          v-else
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span
            @click="handleClickLookContract({ applyNo: signInfo.applyNo })"
            >{{ signInfo.name }}</span
          >
        </el-tooltip>
      </template>
      <!--已完成-->
      <template v-else-if="signInfo.status === 1">
        <el-tooltip
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span
            @click="handleClickLookContract({ applyNo: signInfo.applyNo })"
            >{{ signInfo.name }}</span
          >
        </el-tooltip>
      </template>
      <!--其他情况-->
      <template v-else-if="signInfo.status === -5 || signInfo.status === 2">
        <el-tooltip
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span
            @click="handleClickLookContract({ applyNo: signInfo.applyNo })"
            >{{ signInfo.name }}</span
          >
        </el-tooltip>
      </template>
      <template v-else-if="signInfo.status === -6">
        <el-tooltip
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span @click="$message.error('文件已过期')">{{ signInfo.name }}</span>
        </el-tooltip>
      </template>
      <template v-else>
        <el-tooltip
          effect="dark"
          :content="signInfo.name || signInfo.contractName"
          placement="bottom-start"
        >
          <span
            @click="handleClickLookContract({ applyNo: signInfo.applyNo })"
            >{{ signInfo.name || signInfo.contractName }}</span
          >
        </el-tooltip>
      </template>
    </template>
    <template v-else-if="applyType === 'applyList'">
      <!--待签的-->
      <template v-if="signInfo.status === 0">
        <!--待我签-->
        <el-tooltip
          v-if="signInfo.selfSign === 1"
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <!--          <span @click="toSign(signInfo.signNo, signInfo.approveId)">{{-->
          <span
            @click="
              handleClickLookContract(signInfo.signNo, signInfo.approveId)
            "
            >{{ signInfo.name }}</span
          >
        </el-tooltip>
        <!--待ta签-->
        <el-tooltip
          v-else
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span
            @click="handleClickLookContract({ applyNo: signInfo.applyNo })"
            >{{ signInfo.name }}</span
          >
        </el-tooltip>
      </template>
      <!--已过期-->
      <template v-else-if="signInfo.status === -6">
        <el-tooltip
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span @click="$message.error('文件已过期')">{{ signInfo.name }}</span>
        </el-tooltip>
      </template>
      <!--已完成-->
      <template v-else>
        <el-tooltip
          effect="dark"
          :content="signInfo.name || signInfo.contractName"
          placement="bottom-start"
        >
          <span
            @click="handleClickLookContract({ applyNo: signInfo.applyNo })"
            >{{ signInfo.name || signInfo.contractName }}</span
          >
        </el-tooltip>
      </template>
    </template>
    <goto-auth :default="authDialog"></goto-auth>
  </div>
</template>

<script>
import SignContract from "@/assets/js/http-serve/signInfoController";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods"
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  name: "contractName",
  data () {
    return {
      authDialog: false
    };
  },
  props: {
    signInfo: {
      type: Object
    },
    applyType: {
      type: String
    },
    enterpriseSubjectType: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    // 前往签署
    toSign (signNo, approveId) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        this.loading = this.$loading({ lock: true });
        let new_window;
        if (!isInDingTalk) new_window = window.open("", "_blank");
        SignContract.postSignUrl(signNo)
          .then(({ data }) => {
            let path = this.signInfo.multiFile
              ? "/initiation/viewDetail"
              : "/signInfo/viewDetail";
            this.loading.close();
            data.approveId = approveId;
            let router = this.$router.resolve({ path: path, query: data });
            let href = isInDingTalk ? location.origin + router.href : window.location.origin + router.href;
            isInDingTalk ? location.href = href : new_window.location.href = href;
            // 设置token
            localStorage.setItem("JZQ_SIGN_TOKEN_KEY", data.tokenKey);
            localStorage.setItem("JZQ_SIGN_TOKEN", data.token);
          })
          .catch(err => {
            this.loading.close();
            if (!isInDingTalk) new_window.close();
            this.$confirm(err.description, "系统提示", {
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => { });
          });
      } else {
        this.authDialog = true;
      }
    },
    // 前往合同详情
    toApplyDetail ({ applyNo, signNo }) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        var param = {
          signNo: signNo,
          applyNo: applyNo,
          multiFile: this.signInfo.multiFile
        };
        this.loading = this.$loading({ lock: true });
        let newWindow = '';
        if (!isInDingTalk) newWindow = window.open();
        ApiCorpMethods.ContractController.viewUrl(param)
          .then(url => {
            this.loading.close();
            isInDingTalk ? location.href = url : newWindow.location.href = url;
          })
          .catch(err => {
            this.loading.close();
            if (!isInDingTalk) newWindow.close();
            this.$message.error(err.description || "无法查看该合同");
            console.error("toApplyDetail: " + JSON.stringify(err));
          });
      } else {
        this.authDialog = true;
      }
    },
    // 查看合同
    async handleClickLookContract () {
      let row = this.signInfo;
      let params = {};
      let newWind = '';
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((row.applyNo && row.applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      if (!isInDingTalk) newWind = window.open();
      params.applyNo = row.applyNo;
      params.multiFile = row.multiFile;
      if ([1, 2].includes(this.enterpriseSubjectType)) {
        ApiMethods.UserApplySignController.viewUrl({
          ...params,
          corpQuery: 1,
        })
          .then(res => {
            if (res.code === "0") {
              let { href } = row.multiFile
                ? this.$router.resolve({
                  path: "/applySign/toDetailMultiAnony",
                  query: Object.assign({}, res.data, {
                    approveId: row.approveId,
                    aiCorpUserIdFlag: row.aiCorpUserIdFlag
                  })
                })
                : this.$router.resolve({
                  path: "/applySign/toDetailAnony",
                  query: Object.assign({}, res.data, {
                    approveId: row.approveId
                  })
                });
              href = isInDingTalk ? location.origin + href : window.location.origin + href;
              isInDingTalk ? location.href = href : newWind.location.href = href;
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(error => {
            this.$message.error(error.description);
          });
      }
      ApiCorpMethods.ContractController.viewUrl(params)
        .then(res => {
          if (res.code === "0") {
            let { href } = row.multiFile
              ? this.$router.resolve({
                path: "/applySign/toDetailMultiAnony",
                query: Object.assign({}, res.data, {
                  approveId: row.approveId,
                  aiCorpUserIdFlag: row.aiCorpUserIdFlag
                })
              })
              : this.$router.resolve({
                path: "/applySign/toDetailAnony",
                query: Object.assign({}, res.data, {
                  approveId: row.approveId
                })
              });
            href = isInDingTalk ? location.origin + href : window.location.origin + href;
            isInDingTalk ? location.href = href : newWind.location.href = href;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
  }
};
</script>

<style lang="less" scoped>
.contract-name {
  line-height: 30px;
  overflow: hidden;
  /*max-width: 60%; // 解决safari下太宽问题*/

  & > span {
    max-width: 100%;
    display: inline-block;
    line-height: 1;
    padding: 3px 0;
    vertical-align: middle;
    cursor: pointer;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-y: hidden;
    color: #290202;
    font-weight: 800;
    font-size: 16px;

    &:hover {
      border-bottom: solid 1px #ec1c1c;
      color: #ec1c1c;
    }
  }

  .insure-icon {
    margin-right: 5px;
    vertical-align: middle;
    position: absolute;
    left: -20px;
    cursor: pointer;
    &.no {
      color: #ec1c1c;
    }
    &.yes {
      color: green;
    }
  }
}
.authDialog {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 40px;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(41, 2, 2, 0.65);

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
/deep/ .el-button--small:hover {
  opacity: 0.7 !important;
}
</style>



// WEBPACK FOOTER //
// components/apply-list/contract-name-member.vue